import React, { Fragment } from 'react';
import { getFundMainClass } from '@finect/front-resources/Products';
import { PercentLabel } from '../../../Labels';
export var FundClassFee = function FundClassFee(_ref) {
  var product = _ref.product;
  var fundClass = getFundMainClass(product.entity);
  var classFees = fundClass.fees ? fundClass.fees : null;
  if (!classFees) {
    return null;
  }
  var mgr = classFees.mgr,
    suc = classFees.suc;
  return React.createElement(Fragment, null, mgr ? React.createElement(PercentLabel, {
    decimals: 3,
    value: mgr.value
  }) : null, mgr && suc ? React.createElement("span", null, " + ") : null, suc ? React.createElement(PercentLabel, {
    decimals: 3,
    value: suc.value
  }) : null);
};